import axios from 'axios';
import { to } from 'await-to-js';

const {
    REACT_APP_API_URL
} = process.env;


export async function loginUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/login`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerUsuarios() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/usuarios/obtener`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function agregarUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/agregar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/editar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/eliminar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarToken(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/eliminar-token`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarPerfilUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/usuarios/editar-perfil`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}